import Helmet from 'next/head';
import React, { memo } from 'react';
import { host } from 'sly/config';

const ProviderSeo = ({ partnerCollection }) => {
  const {
    url,
    name,
    info: { communityPartnerCollectionStats: { communityCount } = {} } = {},
  } = partnerCollection || {};

  const title = `${name}: All ${communityCount} Properties`;

  const description = `Learn about ${name} and their mission. Explore all ${communityCount} ${name} locations to see if one suits your family's needs.`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name='description' content={description} />
      <meta
        name='viewport'
        content='width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no'
      />
      <meta httpEquiv='X-UA-Compatible' content='IE=edge,chrome=1' />
      <meta content='Seniorly' property='author' />
      <meta content='English' property='language' />
      <link rel='canonical' href={`${host}${url}`} />

      <meta content={description} property='og:description' />
      <meta content={`${title} | Seniorly`} property='og:title' />
      <meta content={url} property='og:url' />

      <meta content={description} property='twitter:description' />
      <meta content={`${title} | Seniorly`} property='twitter:title' />
    </Helmet>
  );
};

export default memo(ProviderSeo);
